"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorialListLocalizedReferenceSchema = void 0;
exports.EditorialListLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/editorial-lists.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "EditorialListLocalizedReference",
    "description": "An editorial collection content resources for a given topic",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:editorial-lists"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWRpdG9yaWFsLWxpc3RzLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3JlZmVyZW5jZS9sb2NhbGl6ZWQvY29udGVudC9lZGl0b3JpYWwtbGlzdHMuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsS0FBSyxFQUFFLHlGQUF5RjtJQUNoRyxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxpQ0FBaUM7SUFDMUMsYUFBYSxFQUFFLDZEQUE2RDtJQUM1RSxNQUFNLEVBQUUsUUFBUTtJQUNoQixVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sSUFBSTtLQUNMO0lBQ0QsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFO2dCQUNOLDZCQUE2QjthQUM5QjtZQUNELE1BQU0sRUFBRSxRQUFRO1NBQ2pCO1FBQ0QsSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLGlHQUFpRztTQUM3RztLQUNGO0NBQ0YsQ0FBQSJ9